<template>
  <div v-if="data" class="page" v-html="data"></div>
</template>

<script setup lang="ts">
interface Props {
  data?: string;
}

withDefaults(defineProps<Props>(), {
  data: undefined,
});
</script>
